import { render, staticRenderFns } from "./dishDetail.vue?vue&type=template&id=7b363133&scoped=true"
import script from "./dishDetail.vue?vue&type=script&lang=js"
export * from "./dishDetail.vue?vue&type=script&lang=js"
import style0 from "./dishDetail.vue?vue&type=style&index=0&id=7b363133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b363133",
  null
  
)

export default component.exports